import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAppDispatch } from "./reduxHooks";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
